import OverlayLoading from 'components/atoms/OverlayLoading'
import UnavoidableConfirmCancel from 'components/molecules/notificationOverlay/UnavoidableConfirmCancel'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ADD_ASSESSMENT_RATERS, MY_JOURNEY } from 'routes/constants'
import {
  ASSESSMENT_QUESTIONS_SELF_URL,
  ASSESSMENT_URL
} from 'services/constants'
import { getRequest } from 'utils/api'
import { getGoalInfoById } from 'utils/getSupportingInfo'
import AssessmentCard from './AssessmentCard'
import { Button, Dialog, Typography } from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import { TaskSuccessIcon } from 'components/atoms/Icons'
import SelfAssessmentReport from 'components/molecules/assessments/SelfAssessmentReport'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'

const celebrate = require('assets/images/celebrateSmall.png')

const SelfAssessmentCard = ({
  goalId,
  nextStepCallback,
  showLandingPopup = false,
  cohortUser
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [goalData, setGoalData] = useState({})
  const [completed, setCompleted] = useState()
  const [resultData, setResultData] = useState({})
  const [openAssessmentDialogOpen, setOpenAssessmentDialogOpen] =
    useState(false)
  const [questions, setQuestions] = useState([])
  const [landingDialogOpen, setLandingDialogOpen] = useState(showLandingPopup)
  const [congratDialogOpen, setCongratDialogOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  useState(() => {
    const fetchData = async () => {
      const data = await getGoalInfoById(goalId)
      setGoalData(data)
      const res = await getRequest(ASSESSMENT_URL, { goalId })
      if (res?.status === 200) {
        if (res.data.data.isOpen) {
          setOpenAssessmentDialogOpen(true)
          return
        }
      }

      const quesRes = await getRequest(ASSESSMENT_QUESTIONS_SELF_URL, {
        goalId
      })
      if (quesRes.status === 200) {
        setQuestions(quesRes.data.data)
      }
      setLoading(false)
    }

    if (goalId) {
      setLoading(true)
      fetchData()
    }
  }, [goalId])

  const submittedCallback = result => {
    setResultData(result)
    setCongratDialogOpen(true)
  }

  const handleComplete = () => {
    setCompleted(true)
    setCongratDialogOpen(false)
  }

  const handleOpenAssessmentRedirect = addRaters => {
    if (addRaters) {
      navigate(`${ADD_ASSESSMENT_RATERS}/${goalId}`)
    } else {
      navigate(MY_JOURNEY)
    }
  }
  return (
    <>
      {completed ? (
        <SelfAssessmentReport
          resultData={resultData}
          disableBehaviorClick={true}
          nextStepCallback={nextStepCallback}
        />
      ) : questions.length ? (
        <AssessmentCard
          selfAssessment={true}
          goalId={goalId}
          goalData={goalData}
          questions={questions}
          submittedCallback={submittedCallback}
        />
      ) : null}
      <OverlayLoading open={loading} />
      <UnavoidableConfirmCancel
        open={openAssessmentDialogOpen}
        subtitle={`${t('assessmentTimeline.alreadyCompletedSelfassessment')} ${t('assessmentTimeline.addMore360Raters')}`}
        highFocusAction={() => handleOpenAssessmentRedirect(true)}
        lowFocusAction={() => handleOpenAssessmentRedirect(false)}
        highFocusText={t('assessmentTimeline.addRaters')}
        lowFocusText={t('assessmentTimeline.returnMyJourney')}
      />
      <Dialog open={congratDialogOpen} onClose={handleComplete}>
        <InCardStack
          width='450px'
          justifyContent='flex-end'
          padding={20}
          sx={{
            background: `url(${celebrate}) no-repeat`,
            backgroundSize: 'cover',
            backgroundPositionY: -50,
            paddingTop: '170px',
            paddingBottom: '40px'
          }}>
          <TaskSuccessIcon size={80} />
          <Typography textAlign='center' variant='h3'>
            {t('assessmentTimeline.completingSelfAssessment.part1')} <br />{' '}
            {t('assessmentTimeline.completingSelfAssessment.part2')}
          </Typography>
          <Button onClick={handleComplete}>
            {t('stepQuiz.reviewMyResults')}
          </Button>
        </InCardStack>
      </Dialog>
      <CommonDialog
        open={landingDialogOpen}
        onClose={() => setLandingDialogOpen(false)}
        confirmText={t('common.ok')}
        titleText={t('assessments.completeFirst')}>
        <Typography>
          {t(
            cohortUser
              ? 'assessments.cohortPathAssessment'
              : 'assessments.nonCohortPathAssessment',
            { goalName: goalData.name }
          )}
        </Typography>
        {cohortUser && (
          <Typography>{t('assessments.cohortPathAssessment1')}</Typography>
        )}
      </CommonDialog>
    </>
  )
}

export default SelfAssessmentCard
